import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './List';
import AddOrEdit from "./AddOrEdit"

const ContractReports = props => {
  return (
    <Switch>
      <Route path="/cafes-contract/add" exact render={routeProps => <AddOrEdit {...routeProps} editMode={false} />} />
      <Route path="/cafes-contract/edit" exact render={routeProps => <AddOrEdit {...routeProps} editMode={true} />} />
      <Route path="/" component={List} />
    </Switch>
  );
};

export default ContractReports;